import type { Meta } from '@cubejs-client/core'

import { shortName, toField } from '@/lib/cube-report'

export type MemberKind = 'measure' | 'dimension' | 'time'

export interface PickerOption {
  /** View için view adı, üye için kısa ad (`girisTL`). */
  value: string
  label: string
}

/** Kullanıcının görebildiği view'lar (meta token yetkisiyle süzülü). Etiket: view başlığı. */
export function listViews(meta: Meta): PickerOption[] {
  return meta.cubes
    .filter((cube) => cube.type === 'view')
    .map((cube) => ({ value: cube.name, label: cube.title || cube.name }))
}

/** View'ın üyeleri; `time` = zaman boyutları, `dimension` = zaman dışındakiler. */
export function listMembers(meta: Meta, view: string, kind: MemberKind): PickerOption[] {
  const cube = meta.cubes.find((c) => c.type === 'view' && c.name === view)
  if (!cube) return []
  const members =
    kind === 'measure'
      ? cube.measures.map((m) => toField(m, true))
      : cube.dimensions
          .map((m) => toField(m, false))
          .filter((field) => (field.type === 'time') === (kind === 'time'))
  return members.map((field) => ({ value: shortName(field.name), label: field.label }))
}
